import { useEffect, useState } from "react";
import axiosAdmin from "../../../../api/apiAdmin";
import { successToast, errorToast } from "../../toastAlerts/ToastAlerts";
import TemplateCard from "./TemplateCard";

/**
 * The notification wording, editable per event.
 *
 * Email and SMS are edited separately because they are genuinely different
 * messages: the email can be warm and use emoji, the SMS is transliterated to
 * Latin by a gateway that renders no Unicode and charges per 160 characters.
 */
const MessageTemplatesPage = () => {
   const [templates, setTemplates] = useState([]);
   const [loading, setLoading] = useState(true);

   const load = () =>
      axiosAdmin
         .get("/messageTemplates")
         .then(({ data }) => setTemplates(data || []))
         .catch(() => errorToast("შეცდომა"))
         .finally(() => setLoading(false));

   useEffect(() => {
      load();
   }, []);

   const replace = (updated) =>
      setTemplates((prev) => prev.map((t) => (t.id === updated.id ? updated : t)));

   return (
      <div
         className="xl:ml-[280px] mt-[55px] bg-slate-100 dark:bg-slate-900 min-h-screen
            p-10 sm:p-5 pb-24 flex flex-col gap-5"
      >
         <div>
            <h1 className="text-xl font-bold text-[#777a83] dark:text-gray-200">
               შეტყობინებების ტექსტები
            </h1>
            <p className="text-xs text-[#989ba5] mt-1 max-w-3xl leading-snug">
               მეილი და SMS ცალ-ცალკე იწერება. SMS ლათინურად გარდაიქმნება გაგზავნისას
               და ყოველი 160 სიმბოლო ცალკე შეტყობინებად ითვლება — სიგრძე ქვემოთ
               ნაჩვენებია უკვე გარდაქმნილ ტექსტზე.
            </p>
         </div>

         {loading ? (
            <div className="animate-pulse h-64 bg-white dark:bg-slate-700 rounded-xl" />
         ) : (
            templates.map((t) => (
               <TemplateCard
                  key={t.id}
                  template={t}
                  onSaved={(updated) => {
                     replace(updated);
                     successToast("შენახულია");
                  }}
                  onError={(m) => errorToast(m || "შეცდომა")}
               />
            ))
         )}
      </div>
   );
};

export default MessageTemplatesPage;
